import { render } from "./recoverypwd.vue?vue&type=template&id=3eee0160"
import script from "./recoverypwd.vue?vue&type=script&lang=js"
export * from "./recoverypwd.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__